import { InferGetStaticPropsType } from 'next'

import { VenueEventMeta } from '@modules/event/views/event-meta'
import { EventDetails } from '@modules/event/controllers/event-details'

import { ssgPaths, ssgProps } from '@utils/server'
import { serveEventDetailsProps } from '@modules/event/data/server'
import { VenuePageProvider } from '@modules/venue/controllers/venue-page-provider'
import { useMemo } from 'react'
import { VenuePageNavigation } from '@modules/venue/views/venue-page-navigation'

export default function VenueEventPage({
  venue,
  integrations,
  event,
  tickets,
  packages,
  layouts,
  sections,
  tables,
  inventoryCalendarMinDate,
  inventoryCalendarMaxDate,
  eventPassed,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const breadcrumbs = useMemo(
    () => [
      {
        label: 'Venue',
        href: `/v/${venue.slug}`,
      },
      {
        label: 'All Events',
        href: `/v/${venue.slug}/events`,
      },
      {
        label: 'Event',
        href: `/e/${event.id}`,
      },
    ],
    [event.id, venue.slug]
  )

  return (
    <>
      <VenueEventMeta venue={venue} event={event} />
      <VenuePageProvider
        venue={venue}
        event={event}
        integrations={integrations}
      >
        <div className='mx-auto max-w-7xl'>
          <div className='mx-3'>
            <VenuePageNavigation breadcrumbs={breadcrumbs} className='!px-0' />
          </div>
        </div>
        <EventDetails
          venue={venue}
          event={event}
          tickets={tickets.data}
          packages={packages.data}
          layouts={layouts}
          sections={sections}
          tables={tables}
          inventoryCalendarMinDate={inventoryCalendarMinDate}
          inventoryCalendarMaxDate={inventoryCalendarMaxDate}
          eventPassed={eventPassed}
        />
      </VenuePageProvider>
    </>
  )
}

export const getStaticProps = ssgProps(serveEventDetailsProps)
export const getStaticPaths = ssgPaths()
